//Map des noms 
export const TANKTYPE_N = "N";
export const TANKTYPE_PG = "PG";
export const TANKTYPE_G = "G";
export const TANKTYPE_A = "A";

export const TANK_CYCLES = [
    TANKTYPE_N,
    TANKTYPE_PG,
    TANKTYPE_G,
    TANKTYPE_A
]